









import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { Vector2 } from '@/utilityModels/vector2';

import { UserAgentHelper } from '@/helper/userAgentHelper';

@Component({
    components: {
    },
})
export default class SizeController extends Vue 
{
    private isMobile() { return UserAgentHelper.isMobile(); }

    @Prop() private layer! : Layer | null;
    @Prop() private scale! : number;
    @Prop() private cursorWidth! : number;
    @Prop() private cursorHeight! : number;
    @Prop() private offsetX! : number;
    @Prop() private offsetY! : number;

    private get cx()
    {
        // 右下の座標
        if(this.layer == null) { return 0; }
        return this.layer.getVertexes()[2].x * this.scale + this.offsetX;
    }

    private get cy()
    {
        // 右下の座標
        if(this.layer == null) { return 0; }
        return this.layer.getVertexes()[2].y * this.scale + this.offsetY;
    }

    private get r()
    {
        return Math.max(this.cursorWidth, this.cursorHeight) / 2;
    }

    private get iconWidth()
    {
        return Math.max(this.cursorWidth, this.cursorHeight) * 20 / 32;
    }

    private get iconHeight()
    {
        return Math.max(this.cursorWidth, this.cursorHeight) * 20 / 32;
    }

    private get transform()
    {
        if(this.layer == null) { return ""; }

        var transform = "";

        transform += "translate(" + this.cx + " " + this.cy + "),";

        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";

        transform += "translate(" + (-this.cx) + " " + (-this.cy) + ")";
        
        return transform;
    }

    private selectPoint()
    {
        this.$emit("selectPoint");
    }
}
